<template>
    <div id="photos">
        <p>Bij dit onderdeel kun je maximaal 8 foto’s uploaden. Je moet minimaal 4 foto’s uploaden om je inschrijving te kunnen afronden.
            <br><br>
            Uitleg:<br>
            Nadat je een foto hebt upgeload krijg je de mogelijkheid om deze in de juiste verhouding uit te snijden. De foto is dan precies op het juiste formaat voor plaatsing in ons bestand.
        </p>
        <cropper :src="'1'" :enabled="noofPhotos > -1"></cropper>
        <cropper :src="'2'" :enabled="noofPhotos > 0"></cropper>
        <cropper :src="'3'" :enabled="noofPhotos > 1"></cropper>
        <cropper :src="'4'" :enabled="noofPhotos > 2"></cropper>
        <cropper :src="'5'" :enabled="noofPhotos > 3"></cropper>
        <cropper :src="'6'" :enabled="noofPhotos > 4"></cropper>
        <cropper :src="'7'" :enabled="noofPhotos > 5"></cropper>
        <cropper :src="'8'" :enabled="noofPhotos > 6"></cropper>
        <p>
            Heb je geen duidelijke of professionele foto’s van jezelf? Dan kun je deze via ons laten maken. <a href="https://dutchcasting.nl/intake/photoshoot" target="_blank">Hier vind je meer informatie over onze fotografie pakketten</a>.
        </p>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    import Cropper from './Cropper.vue'


    export default {
        components: {
            Cropper
        },
        data: function () {
            return {
                submitted: false,
            }
        },
        mounted() {
        },
        computed: {
            noofPhotos() {
                return this.$store.getters.noofPhotos()
            },
        },
        watch: {},
        methods: {
        },
    };
</script>